import {createSubmittal$, deleteSubmittal$, getSubmittals$, updateSubmittal$} from "../services/projects";
import {networkError} from "./ui";
import {extractSubview} from "./view";

export const ADD_SUBMITTALS = 'ADD_SUBMITTALS';
export const addSubmittals = (list) => ({type: ADD_SUBMITTALS, payload: list});
export const API_GET_SUBMITTALS = 'API_GET_SUBMITTALS';
export const getSubmittals = (projectId, offset) => ({type: API_GET_SUBMITTALS, payload: {projectId, offset}});
export const API_GET_SUBMITTALS_DONE = 'API_GET_SUBMITTALS_DONE';
export const getSubmittalsDone = (response) => ({type: API_GET_SUBMITTALS_DONE, payload: response});
export const API_GET_SUBMITTAL = 'API_GET_SUBMITTAL';
export const getSubmittal = (projectId, id) => ({type: API_GET_SUBMITTAL, payload: {projectId, id}});
export const API_GET_SUBMITTAL_DONE = 'API_GET_SUBMITTAL_DONE';
export const getSubmittalDone = (response, callback) => ({ type: API_GET_SUBMITTAL_DONE, payload: { response, callback } });

export const createSubmittal = (projectId, submittal, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await createSubmittal$({ projectId, document: submittal }).toPromise();
    ({ response, status } = await getSubmittals$({ id: response, projectId }).toPromise());
    dispatch(getSubmittalDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10131-'+error.status}));
  }
};

export const deleteSubmittal = (projectId, submittalId) => async (dispatch, getState) => {
  try {
    let { response, status } = await deleteSubmittal$({ projectId, subId: submittalId }).toPromise();
    dispatch(extractSubview([submittalId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10132-'+error.status}));
  }
};

export const updateSubmittal = (projectId, submittal) => async (dispatch, getState) => {
  try {
    let submittalId = submittal.id;
    let { response, status } = await updateSubmittal$({ projectId, subId: submittalId, document: submittal }).toPromise();
    let { response: response2, status: status2 } = await getSubmittals$({ projectId, id: submittalId }).toPromise();
    dispatch(getSubmittalDone(response2));
  } catch (error) {
    dispatch(networkError({...error, number: '10133-'+error.status}));
  }
};




// WEBPACK FOOTER //
// ./src/actions/submittals.js